import React, { Component } from "react"

function expandableItem(WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props)
            this.state = {
                isExpanded: false
            }
            this.toggleExpansion = this.toggleExpansion.bind(this)
        }

        toggleExpansion() {
            this.setState({
                isExpanded: !this.state.isExpanded
            })
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    isExpanded={this.state.isExpanded}
                    toggleExpansion={this.toggleExpansion}
                />
            )
        }
    }
}

export default expandableItem
